import React, { Fragment } from 'react';
const words = [{
  text: 'Pre-Market',
  hi: true
}, {
  text: 'Prestige Residential',
  hi: false
}, {
  text: 'Commercial',
  hi: true
}, {
  text: 'Microsites',
  hi: false
}, {
  text: 'Motion-Led Marketing',
  hi: true
}, {
  text: 'Melbourne',
  hi: false
}];
export function MarqueeStrip() {
  return <div className="border-y border-tux-border bg-[#0D0D0D] py-[20px] overflow-hidden" data-id="element-93">
      <div className="marquee-track flex whitespace-nowrap" data-id="element-94">
        {[0, 1].map(set => <div key={set} className="flex items-center shrink-0" data-id="element-95">
            {words.map((word, i) => <Fragment key={`${set}-${i}`} data-id="element-96">
                <span className={`font-mono text-[10px] tracking-[0.3em] uppercase px-[28px] shrink-0 ${word.hi ? 'text-[rgba(200,255,0,0.55)]' : 'text-tux-muted'}`} data-id="element-97">
                  {word.text}
                </span>
                <span className="text-[rgba(200,255,0,0.2)] px-[4px]" data-id="element-98">·</span>
              </Fragment>)}
          </div>)}
      </div>
    </div>;
}